export default "__VITE_ASSET__606HtJuZ__"